import api from "./portalAPI";

const service = {
  getAll() {
    return api.get(`/Estado`);
  },
};

export default service;
